// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"121":"cf72a0b7","586":"8e801a8a"}[chunkId] + ".css";
};